import { useMemo } from 'react';

import styled from '@emotion/styled';
import { IconButtonGhost, Typography } from '@kc-console/common-ui';
import { useServiceAppState } from '@kc-console/context';
import { useTranslation } from '@kc-console/core';
import IcCloseLargeRegular from '@kep/kcds-icons/IcCloseLargeRegular';

import { useRefinedProjectMenuState } from '../../../hooks';

interface Props {
  onClose: () => void;
}

const Header = ({ onClose }: Props) => {
  const { t } = useTranslation();
  const {
    state: { region },
  } = useServiceAppState();
  const hasRegion = useMemo(() => !!region, [region]);
  const { accessibleProjects } = useRefinedProjectMenuState();

  const headerTitle = useMemo(() => {
    const hasAccessibleProject = accessibleProjects?.length > 0;

    // 접근 가능한 프로젝트가 없는 경우
    if (!hasAccessibleProject) {
      return t('layout:mega_menu.header.no_accessible_project');
    }

    // 리전 값이 존재하는 경우, 모든 서비스를 보여줄 수 있기 때문에 '모든 서비스' 로 표기
    if (hasRegion) {
      return t('layout:mega_menu.header.all_services');
    }

    // 이외에 케이스에서 헤더 타이틀은 프로젝트 선택을 유도하는 메세지로 표기
    return t('layout:mega_menu.header.no_current_project');
  }, [hasRegion, accessibleProjects, t]);

  return (
    <StyledHeaderWrapper>
      <StyledHeaderContainer>
        <Typography variant={'heading/bold/3xl'}>{headerTitle}</Typography>
        <IconButtonGhost size={'lg'} aria-label={t('common:common.action.close')} onClick={onClose}>
          <IcCloseLargeRegular />
        </IconButtonGhost>
      </StyledHeaderContainer>
    </StyledHeaderWrapper>
  );
};

const StyledHeaderWrapper = styled.div`
  padding-bottom: 16px;
`;

const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default Header;
